import { supabase } from './supabase.js';

/** Identité bar : session anonyme Supabase + ligne public.bar_users. */

const GUEST_ANIMALS = [
  'Renard',
  'Lynx',
  'Faucon',
  'Hibou',
  'Loutre',
  'Panthère',
  'Cobra',
  'Jaguar',
  'Caméléon',
  'Lézard',
  'Corbeau',
  'Tigre',
  'Loup',
  'Phénix',
  'Dauphin',
  'Aigle',
  'Mante',
  'Lutin',
  'Wallaby',
  'Mantis',
];

const GUEST_VIBES = [
  'néon',
  'tonnerre',
  'éclair',
  'velours',
  'cosmos',
  'rave',
  'minuit',
  'sirène',
  'galaxie',
  'mirage',
  'aurore',
  'disco',
  'vinyle',
  'platine',
  'sapphir',
  'écho',
  'phonik',
  'dancefloor',
];

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function generateGuestUsername() {
  const num = String(Math.floor(Math.random() * 999)).padStart(2, '0');
  return `${pick(GUEST_ANIMALS)}-${pick(GUEST_VIBES)}-${num}`;
}

/** Session JWT (dont auth anonyme), sans friction email.
 * @returns {{ signInError: string | null }} signInError si signInAnonymously a été tenté et a échoué */
export async function ensureAnonymousAuth() {
  const {
    data: { session: existing },
    error: getErr,
  } = await supabase.auth.getSession();
  if (getErr) {
    // eslint-disable-next-line no-console
    console.warn('[bar-auth] getSession', getErr.message);
  }
  if (existing?.user) return { signInError: null };

  const { data, error } = await supabase.auth.signInAnonymously();
  if (error) {
    // eslint-disable-next-line no-console
    console.warn('[bar-auth] signInAnonymously', error.message);
    return { signInError: error.message };
  }
  if (!data?.session) {
    return { signInError: 'Aucune session retournée après connexion anonyme.' };
  }
  return { signInError: null };
}

/** Crée un compte e-mail OU lie l'e-mail au compte courant.
 * Si l'utilisateur courant est ANONYME, on lie l'e-mail + mot de passe au MÊME
 * compte via updateUser() : on conserve l'auth_user_id, donc la ligne bar_users,
 * le pseudo, les votes et la progression. signUp() créerait un nouvel utilisateur
 * et abandonnerait l'identité invité (bug : pseudo perdu).
 * @returns {{ error: object | null, linked: boolean }} linked=true si conversion d'anonyme */
export async function claimAccountWithEmail(email, password) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const isAnonymous = session?.user?.is_anonymous === true;

  if (isAnonymous) {
    const { error } = await supabase.auth.updateUser({ email, password });
    return { error, linked: true };
  }

  const { error } = await supabase.auth.signUp({ email, password });
  return { error, linked: false };
}

/** @returns {{ data: object | null, error: object | null }} */
export async function fetchBarUserByAuth(authUserId) {
  if (!authUserId) return { data: null, error: null };
  const { data, error } = await supabase
    .from('bar_users')
    .select('id, username, avatar_url, featured_badge_code, is_guest, auth_user_id, created_at')
    .eq('auth_user_id', authUserId)
    .maybeSingle();
  if (error) {
    // eslint-disable-next-line no-console
    console.warn('[bar-users] select', error.message);
    return { data: null, error };
  }
  return { data, error: null };
}

export async function insertGuestBarUser(authUserId) {
  for (let i = 0; i < 10; i += 1) {
    const username = generateGuestUsername();
    const { data, error } = await supabase
      .from('bar_users')
      .insert({
        auth_user_id: authUserId,
        username,
        is_guest: true,
      })
      .select('id, username, avatar_url, featured_badge_code, is_guest, auth_user_id, created_at')
      .single();

    if (data && !error) return { data };

    if (error?.code === '23505') {
      const again = await fetchBarUserByAuth(authUserId);
      if (again.data) return { data: again.data };
      continue;
    }
    return { error };
  }
  return {
    error: { message: 'Impossible de générer un pseudo Invité disponible.', code: 'USERNAME_TAKEN' },
  };
}
